import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  border: 1px dashed ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
  text-align: center;

  & > p {
    margin: 0;
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: 14px;
  }
`;

export const EntryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.common.white};
`;

export const EntryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EntryTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey[900]};
`;

export const SubField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SubFieldLabel = styled.label<{ $required?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grey[800]};

  ${({ $required, theme }) =>
    $required &&
    `
    &::after {
      content: ' *';
      color: ${theme.palette.error.main};
    }
  `}
`;

export const SubFieldError = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.error.main};
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
`;

export const Total = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey[700]};
`;

// Read-only record display (RepeatingGroupDisplay)
export const DisplayList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const NoEntries = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const DisplayRow = styled.div`
  display: flex;
  gap: 8px;
  font-size: 14px;
`;

export const DisplayLabel = styled.span`
  min-width: 120px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
